"use client";

import { createContext, useContext, useMemo } from "react";
import { getTranslator, type Translator } from "@i18n";
import { DEFAULT_UI_LOCALE, type UiLocale } from "@lib/locale";

const I18nContext = createContext<Translator | null>(null);

export function I18nProvider({
  locale = DEFAULT_UI_LOCALE,
  children,
}: {
  locale?: UiLocale;
  children: React.ReactNode;
}) {
  const value = useMemo(() => getTranslator(locale), [locale]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useTranslations(): Translator {
  const ctx = useContext(I18nContext);
  if (!ctx) {
    return getTranslator(DEFAULT_UI_LOCALE);
  }
  return ctx;
}
